var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:[_vm.prefix + 'proj-icon', _vm.fontClass, _vm.baseType + '-' + _vm.type],style:(_vm.styles)})}
var staticRenderFns = []

export { render, staticRenderFns }